import { z } from 'zod';
export const workforceEmployeeProfileHostCapability = 'workforce.employee-profile-host.v1';
export const workforceEmployeeProfileHostSlots = {
    status: 'workforce.employee-profile.status',
};
export const workforceEmployeeProfileHostResourceType = 'workforce.membership-profile';
export const workforceEmployeeProfileHostContextSchema = z.strictObject({
    resourceType: z.literal(workforceEmployeeProfileHostResourceType),
    resourceId: z.string().uuid(),
    parameters: z.strictObject({
        resourceLabel: z.string().trim().min(1).max(240),
    }),
});
//# sourceMappingURL=workforce-employee-profile-host.contract.js.map